// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__3A1SM","frame":"Dialog_frame__2vf4_","closeButton":"Dialog_closeButton__2Wv7J","okButton":"Dialog_okButton__3wJkj","body":"Dialog_body__1JKUr"};